import { Scrollbar } from 'shared/ui'
import { DetailsKeywordBody, DetailsKeywordHeader } from './Details'
import styles from './styles.module.scss'

export const DetailsKeywordModalContent = () => {
  return (
    <Scrollbar>
      <div className={styles.wrap}>
        <DetailsKeywordHeader />
        <DetailsKeywordBody />
      </div>
    </Scrollbar>
  )
}
